import { GroupBase, StylesConfig } from "react-select";

export const subjectSearchSelectStyles = (
  error?: any,
  customStyles?: StylesConfig<any, any, GroupBase<any>> | undefined,
  lookLikeTextField?: boolean,
) => {
  const controlBase = (baseStyles: any) => ({
    ...baseStyles,
    ...(lookLikeTextField
      ? {
          borderRadius: 0,
          borderWidth: 0,
          borderBottomWidth: "1px",
          borderStyle: "solid",
          borderColor: error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)",
          boxShadow: "none",
          minHeight: "32px",
          "&:hover": {
            borderBottomColor: error ? "#d32f2f" : "rgba(0, 0, 0, 0.87)",
          },
        }
      : {
          borderRadius: "0.75rem",
          borderColor: error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)",
        }),
  });

  const valueContainerBase = (baseStyles: any) => ({
    ...baseStyles,
    padding: lookLikeTextField ? "0.25rem 0" : "0.75rem",
    borderRadius: lookLikeTextField ? 0 : "0.75rem",
  });

  const clearIndicatorBase = (base: any) => ({
    ...base,
    color: lookLikeTextField ? undefined : "#ba78de",
    backgroundColor: lookLikeTextField ? "transparent" : "#f4f2f2",
    borderRadius: lookLikeTextField ? "50%" : "0.75rem",
    marginRight: "0.3rem",
    padding: "4px",
    cursor: lookLikeTextField ? "pointer" : undefined,
    "&:hover": {
      color: lookLikeTextField ? undefined : "#8c1ec8",
      backgroundColor: lookLikeTextField ? "rgba(0, 0, 0, 0.04)" : undefined,
      cursor: lookLikeTextField ? "pointer" : undefined,
    },
  });

  const dropdownIndicatorBase = (base: any) => ({
    ...base,
    ...(lookLikeTextField ? { display: "none" } : {}),
    color: "#ba78de",
    backgroundColor: "#f4f2f2",
    borderRadius: "0.75rem",
    padding: "4px",
    margin: "0 0.3rem",
    "&:hover": {
      color: "#8c1ec8",
    },
  });

  const indicatorsContainerBase = (base: any) => ({
    ...base,
    ...(lookLikeTextField
      ? {
          borderLeft: "none",
          paddingLeft: 0,
        }
      : {}),
  });

  const indicatorSeparatorBase = (base: any) => ({
    ...base,
    ...(lookLikeTextField ? { display: "none" } : {}),
  });

  return {
    clearIndicator: clearIndicatorBase,
    indicatorsContainer: indicatorsContainerBase,
    indicatorSeparator: indicatorSeparatorBase,
    placeholder: (baseStyles: any) => ({
      ...baseStyles,
      color: error ? "#d32f2f" : "rgba(0, 0, 0, 0.6)",
      fontWeight: 400,
    }),
    input: (baseStyles: any) => ({
      ...baseStyles,
      margin: "0",
      padding: "0",
      ...(lookLikeTextField ? { fontWeight: 400 } : {}),
    }),
    control: controlBase,
    valueContainer: valueContainerBase,
    dropdownIndicator: dropdownIndicatorBase,
    loadingIndicator: (base: any) => ({
      ...base,
      color: lookLikeTextField ? "rgba(0, 0, 0, 0.6)" : "#ba78de",
    }),
    menuPortal: (base: any) => ({
      ...base,
      borderRadius: "0.75rem",

      zIndex: 99999,
    }),

    option: (styles: any, { isDisabled, isFocused, isSelected }: any) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? "#f4f2f2"
          : isFocused
          ? "#a34bd3"
          : undefined,
        color: isDisabled
          ? undefined
          : isSelected
          ? "black"
          : isFocused
          ? "white"
          : undefined,

        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    multiValue: (baseStyles: any) => ({
      ...baseStyles,
      backgroundColor: "#8c1ec8",
      borderRadius: "0.75rem",
      color: "white",
      padding: "0.25rem 0.5rem 0.25rem 0.25rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "0.25rem",
    }),
    multiValueLabel: (baseStyles: any) => ({
      ...baseStyles,
      color: "white",
    }),
    multiValueRemove: (baseStyles: any) => ({
      ...baseStyles,
      borderRadius: "0.75rem",
      color: "#8c1ec8",
      backgroundColor: "white",

      padding: "0.025rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      ":hover": {
        color: "#ff1744",
      },
    }),
    ...customStyles,
  };
};
